import { render } from "./DocNotFound.vue?vue&type=template&id=7999ca01"
const script = {}
script.render = render

export default script